import React, { useEffect } from 'react';
import { func } from 'prop-types';

import BrowseMenu from '../../BrowseMenu/BrowseMenu';

import css from './MobileNavbar.module.css';

/**
 * Hamburger / Browse-tab surface: the category drill-down (prototype
 * "Browse" view). Escape closes it.
 */
const MobileNavbar = props => {
  const { onClose } = props;

  useEffect(() => {
    const handleKeyDown = e => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [onClose]);

  return (
    <div className={css.megaDropdownMenu}>
      <div className={css.browseWrapper}>
        <BrowseMenu />
      </div>
    </div>
  );
};

MobileNavbar.propTypes = {
  onClose: func.isRequired,
};

export default MobileNavbar;
